module.exports = __webpack_public_path__ + "static/media/25.8a219b02.mp3";